import { FileSpreadsheet } from "lucide-react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { useLanguage } from "@/lib/LanguageContext";

const DomainPreview = ({ domains }) => {
  const { t } = useLanguage();

  return (
    <div className="glass-card rounded-2xl p-8 h-full">
      <h2
        className="text-xl font-bold mb-6 text-white"
        style={{ fontFamily: 'Inter, sans-serif' }}
      >
        {t("preview.title")}
      </h2>

      {domains.length > 0 ? (
        <div className="overflow-hidden rounded-xl border border-white/5">
          <div className="max-h-[420px] overflow-y-auto">
            <Table className="dark-table">
              <TableHeader>
                <TableRow className="border-white/5 hover:bg-transparent">
                  <TableHead className="text-white/40 bg-white/3">#</TableHead>
                  <TableHead className="text-white/40 bg-white/3">{t("preview.tableHeader")}</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {domains.map((domain, index) => (
                  <TableRow key={index} className="border-white/5 hover:bg-white/3">
                    <TableCell className="text-white/40 font-mono text-sm">
                      {index + 1}
                    </TableCell>
                    <TableCell className="font-mono text-sm text-white/80">
                      {domain}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          <div className="bg-white/3 px-4 py-3 border-t border-white/5">
            <p className="text-sm text-white/50">
              <span className="font-bold text-yellow-400">{domains.length}</span>{" "}
              {t("preview.domainsReady", { count: "" }).trim()}
            </p>
          </div>
        </div>
      ) : (
        <div className="h-[420px] flex flex-col items-center justify-center text-white/30 border border-dashed border-white/10 rounded-xl">
          <div className="w-16 h-16 rounded-xl bg-white/3 flex items-center justify-center mb-4">
            <FileSpreadsheet className="w-8 h-8" />
          </div>
          <p className="font-medium">{t("preview.emptyTitle")}</p>
          <p className="text-sm mt-1 text-white/20">{t("preview.emptySubtitle")}</p>
        </div>
      )}
    </div>
  );
};

export default DomainPreview;
